import React, { useState } from "react";
import ButtonC from "../../button";
import styles from "./index.module.scss";
import { useSearchParams } from "react-router-dom";
import { useCheckout } from "../../../../hooks/react-query/inv-exchange/useCheckout";
import { useToast } from "../../toast/toast";
import CheckoutConfirmDialog from "../../checkout-confirm-dialog";

export default function CheckoutBtn({
  acctId,
  setHideInfo,
  isExpired,
  flipperData,
  type,
  propertyId,
  className,
  checkoutBtnWrapClassName,
  onCheckoutSuccess,
  isCoolDownActive
}: {
  acctId: string;
  setHideInfo: (hideInfo: boolean) => void;
  isExpired: boolean;
  type?: string;
  flipperData: any;
  propertyId?: string;
  className?: string;
  checkoutBtnWrapClassName?: string;
  onCheckoutSuccess?: (pubPropertyId: string) => void;
  isCoolDownActive?: boolean;
}) {
  const [showCheckout, setShowCheckout] = useState(false);
  const [searchParams] = useSearchParams();
  const pubPropertyId = propertyId || searchParams.get("pid") || "";
  const pubPropertySfId = searchParams.get("sfid") || "";
  const { showError }: any = useToast();

  const checkOutMutation = useCheckout({
    acctId,
    pubPropertySfId,
    acctSfid: flipperData.acctSfid,
    interestScore: flipperData?.interestScore,
    property_address: `${searchParams.get("street")}, ${searchParams.get(
      "city"
    )}, ${searchParams.get("state")} ${searchParams.get("postalCode")}`,
    onSuccess: async (data: any) => {
      // showSuccess("success", "You have checked out Successfully.");
      setHideInfo(
        isExpired || flipperData?.checkouts?.[0]?.releasedAt !== null
      );
      setShowCheckout(false);
      if (typeof onCheckoutSuccess === "function") {
        onCheckoutSuccess(pubPropertyId);
      }
    },
    onError: (error: any) => {
      showError(
        "error",
        error.response.data.message ||
          "You have reached the maximum number of checkouts"
      );
    }
  });

  return (
    <div
      className={`${styles.checkoutBtnWrap} ${
        type === "list" && styles.list
      } ${checkoutBtnWrapClassName}`}
    >
      {/* ${
          searchParams.get("showIEButton") === "true" ? styles.showIEButton : ""
        } */}
      <ButtonC
        type="button"
        className={`${styles.CheckoutBtn}  ${
          type === "web" && styles.webBtn
        } ${className}`}
        label="CHECKOUT"
        // DND / cooldown disable removed for now
        // disabled={isCoolDownActive}
        disabled={false}
        tabIndex={1}
        onClick={(e: any) => {
          e.stopPropagation();
          setShowCheckout(true);
        }}
        // disabled={checkOutMutation.isPending}
        // loading={checkOutMutation.isPending}
      />
      <CheckoutConfirmDialog
        loading={checkOutMutation.isPending}
        Visible={showCheckout}
        setVisible={setShowCheckout}
        onClick={() => {
          checkOutMutation.mutate({
            acctId: acctId,
            pubPropertyId: pubPropertyId
          });
        }}
      />
    </div>
  );
}
